<template>
  <div class="trip-list">
    <div class="top">
      <img src="@/assets/images/home/trip-bg.jpg" alt="">
    </div>
    <div class="trip-list-div" v-if="scenicSpotList.length > 0">
      <div v-for="(item ,index) in scenicSpotList" :key="index" @click="handleToDetails(item.id)">
        <img :src="item.mainPic[0]" />
        <div class="name">{{item.upname}}</div>
        <div class="downname">{{item.downname}}</div>
        <div class="time">开放时间:{{item.openingTime}}</div>
        <div class="btn">立即预订</div>
        <div class="price-div">
          <span class="money">{{item.consumptionPerPerson}}</span>
        </div>
      </div>
    </div>
    <div v-else class="nodata">暂无数据</div>
  </div>
</template>

<script>
import { config } from '@/constant/config'
import { getAllowSaleList } from '@/api/buyTicket_xqs'

export default {
  components: {
  },
  data () {
    return {
      scenicSpotList: []
    }
  },
  created () {
    document.title = '票务预订'
    this.getAllowSaleList()
    let type = this.$route.query.type
    if (type === 'refresh') {
      this.$emit('loginOut')
      this.$emit('pageIndex', '1')
    }
  },
  mounted () {
  },
  methods: {
    handleToDetails (id) {
      if (!this.$parent.LoginBtnShow) {
        this.$parent.handleLogin()
        return
      }
      this.$router.push({ path: 'tripDetail', query: { id } })
    },
    // 获取景点列表
    getAllowSaleList () {
      getAllowSaleList({
        merchId: config.MERCHID,
        module: 'TRIP',
        tenantId: config.TENANTID
      }).then(res => {
        if (res.code === 0) {
          if (res.data) {
            this.scenicSpotList = res.data.map(item => {
              const pictures = JSON.parse(item.pictures)
              item.mainPic = pictures.find(pic => pic.index === 1).url
              item.upname = item.name.substring(0, 8)
              item.downname = item.name.substring(8)
              return item
            })
          }
        } else {
          this.$message.error(res.error)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.trip-list {
  .top {
    img {
      width: 100%;
      height: 100%;
    }
  }
  .trip-list-div{
    display: grid;
    grid-template-columns: 371px 371px 371px;
    justify-content: center;
    margin-top: 40px;
    >div{
      // height: 343px;
      background: #FFFFFF;
      box-shadow: 0px 3px 16px rgba(24, 60, 80, 0.08);
      margin: 0 32px 20px 0;
      position: relative;
      padding-bottom: 70px;
      img {
        width: 100%;
        height: 200px;
      }
      .name{
        line-height: 27px;
        font-size: 20px;
        font-weight: bold;
        color: #0D111B;
        margin: 20px 0 4px 24px;
        max-width: 190px;
      }
      .downname{
        font-size: 16px;
        font-weight: 400;
        margin: 0 0 10px 24px;
      }
      .time{
        font-size: 14px;
        color: #44516F;
        margin-left: 24px;
      }
      .btn{
        font-size: 20px;
        font-weight: bold;
        color: #9B232A;
        position: absolute;
        left: 50%;
        transform: translate(-50%, -50%);
        line-height: 30px;
        bottom: 0;
        cursor: pointer;
      }
      .price-div{
        width: 90px;
        height: 95px;
        background: #9B232A;
        position: absolute;
        top: 174px;
        right: 24px;
        font-size: 16px;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        .money {
          font-size: 50px;
          font-weight: bold;
          margin: 0 8px 0 4px;
        }
        .money::before{
          content: '￥';
          font-size: 16px;
          font-weight: normal;
        }
      }
    }
    >div:nth-of-type(3n+0)
    {
      margin-right: 0;
    }
  }
}
</style>
